module.exports = __webpack_public_path__ + "373654de37bc8c0e202ef6f2c48e9bca.csv";